"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrganisationCard = exports.OrganisationCardComponent = exports.OrganisationCardDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var content_1 = require("../elements/content");
var card_1 = require("../elements/card");
var image_element_1 = require("../elements/image-element");
var location_label_1 = require("./location-label");
var challenge_label_1 = require("./challenge-label");
var use_entities_1 = require("../../hooks/use-entities");
var use_icons_1 = require("../../hooks/use-icons");
var use_lang_1 = require("../../hooks/use-lang");
var entity_type_icon_label_1 = require("./entity-type-icon-label");
var icon_label_1 = require("../elements/icon-label");
var entity_count_label_1 = require("./entity-count-label");
var entity_cell_header_1 = require("./entity-cell-header");
exports.OrganisationCardDefaultProps = {
  border: 'full'
};
// -------- Styles -------->
var ContentStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-top: ", ";\n    margin-bottom: ", ";\n  "], ["\n    margin-top: ", ";\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(2))
});
var LogoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    margin-right: 2px;\n    align-items: center;\n    justify-content: center;\n    background: #FFF;\n    min-height: 120px;\n  "], ["\n    display: flex;\n    margin-right: 2px;\n    align-items: center;\n    justify-content: center;\n    background: #FFF;\n    min-height: 120px;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    min-height: 180px;\n  "], ["\n    min-height: 180px;\n  "])))
});
var CardStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-top: 8px;\n    box-sizing: border-box;\n    border-bottom: 1px solid ", ";\n    padding: ", " ", ";\n  "], ["\n    margin-top: 8px;\n    box-sizing: border-box;\n    border-bottom: 1px solid ", ";\n    padding: ", " ", ";\n  "])), theme_1.theme.COLOR('line-semi-subtle'), theme_1.theme.UNIT(4), theme_1.theme.UNIT(4))
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: 1.25em;\n    margin-top: ", "; \n    font-weight: 500;\n    color: ", ";\n    ", ";\n    padding-top: ", ";\n\n\n    &:hover {\n      color: ", ";\n    }\n  "], ["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: 1.25em;\n    margin-top: ", "; \n    font-weight: 500;\n    color: ", ";\n    ", ";\n    padding-top: ", ";\n\n\n    &:hover {\n      color: ", ";\n    }\n  "])), theme_1.theme.FONT('sans'), theme_1.theme.FONT_SIZE(21), theme_1.theme.UNIT(1), theme_1.theme.COLOR('bold'), theme_1.theme.H_DOT_BG(), theme_1.theme.UNIT(4), theme_1.theme.COLOR('link-hover'))
});
var ImageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    max-width: 260px;\n    max-height: 140px;\n    img {\n      max-height: 100%;\n    }\n  "], ["\n    max-width: 260px;\n    max-height: 140px;\n    img {\n      max-height: 100%;\n    }\n  "])))
});
var NoLogoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    /* background: ", "; */\n    color: ", ";\n    color: ", ";\n    display: flex;\n    align-items: center;\n    justify-self: flex-start;\n    text-transform: uppercase;\n    font-family: \"Helvetica Neue\", \"Arial\", sans-serif;\n    min-height: 120px;\n    font-size: ", ";\n    /* white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden; */\n    padding: 0;\n    line-height: 1.15em;\n    border-radius: ", ";\n    font-weight: 900;\n  "], ["\n    /* background: ", "; */\n    color: ", ";\n    color: ", ";\n    display: flex;\n    align-items: center;\n    justify-self: flex-start;\n    text-transform: uppercase;\n    font-family: \"Helvetica Neue\", \"Arial\", sans-serif;\n    min-height: 120px;\n    font-size: ", ";\n    /* white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden; */\n    padding: 0;\n    line-height: 1.15em;\n    border-radius: ", ";\n    font-weight: 900;\n  "])), theme_1.theme.COLOR('primary'), theme_1.theme.COLOR('light'), theme_1.theme.COLOR('primary'), theme_1.theme.FONT_SIZE(24), theme_1.theme.UNIT(2)),
  tablet: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    min-height: 180px;\n  "], ["\n    min-height: 180px;\n  "])))
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(2))
});
var IconLabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), LabelStyles)
});
var LocationLabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ChallengeLabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    ", ";\n    color: ", ";\n  "], ["\n    ", ";\n    color: ", ";\n  "])), LabelStyles, theme_1.theme.COLOR('dark'))
});
var HeaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var CountLabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), LabelStyles)
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    ", ";\n    padding-top: ", ";\n  "], ["\n    ", ";\n    padding-top: ", ";\n  "])), theme_1.theme.H_DOT_BG(), theme_1.theme.UNIT(3))
});
// -------- Components -------->
var My = {
  Card: (0, styled_components_1.default)(card_1.Card)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), CardStyles),
  Content: (0, styled_components_1.default)(content_1.Content)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  LocationLabel: (0, styled_components_1.default)(location_label_1.LocationLabel)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), LocationLabelStyles),
  Logo: styled_components_1.default.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), LogoStyles),
  NoLogo: styled_components_1.default.div(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), NoLogoStyles),
  Title: styled_components_1.default.h1(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Image: (0, styled_components_1.default)(image_element_1.ImageElement)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  Label: (0, styled_components_1.default)(entity_type_icon_label_1.EntityTypeIconLabel)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  IconLabel: (0, styled_components_1.default)(icon_label_1.IconLabel)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), IconLabelStyles),
  Body: styled_components_1.default.div(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  ChallengeLabel: (0, styled_components_1.default)(challenge_label_1.ChallengeLabel)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), ChallengeLabelStyles),
  CountLabel: (0, styled_components_1.default)(entity_count_label_1.EntityFieldCountLabel)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), CountLabelStyles),
  Header: (0, styled_components_1.default)(entity_cell_header_1.EntityCellHeader)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles)
};
My.Card = (0, styled_components_1.default)(card_1.Card)(templateObject_29 || (templateObject_29 = __makeTemplateObject(["\n  ", "\n  &:hover {\n    ", " {\n      filter: brightness(110%);\n    }\n  }\n"], ["\n  ", "\n  &:hover {\n    ", " {\n      filter: brightness(110%);\n    }\n  }\n"])), CardStyles, My.Image);
// late definition of default prop, as we need the styled component definitions first
exports.OrganisationCardDefaultProps.renderNoLogo = function (organisation) {
  return React.createElement(My.NoLogo, null, organisation.name);
};
// late definition of default prop, as we need the styled component first
exports.OrganisationCardDefaultProps.renderLogo = function (organisation) {
  return React.createElement(My.Image, {
    entity: organisation.logo
  });
};
var OrganisationCardComponent = function (props) {
  var className = props.className,
    entity = props.entity,
    path = props.path,
    border = props.border,
    renderNoLogo = props.renderNoLogo,
    renderLogo = props.renderLogo,
    label = props.label;
  var Icons = (0, use_icons_1.useIcons)();
  var industries = entity.industries || [];
  var t = (0, use_lang_1.useLang)();
  var entities = (0, use_entities_1.useEntities)();
  var cellLabel = label || entity.type && entity.type.name || entities.Organisation && entities.Organisation.label;
  var feedEntries = entity.feedEntries,
    positions = entity.positions,
    impactStories = entity.impactStories;
  var isMember = entity.isMember;
  return React.createElement(My.Card, __assign({}, props, {
    space: 0,
    className: className,
    to: path,
    image: React.createElement(React.Fragment, null, React.createElement(My.Header, {
      entity: entity,
      badge: isMember && t('Member')
    }, cellLabel), entity.logo ? React.createElement(My.Logo, null, renderLogo(entity)) : renderNoLogo(entity))
  }), React.createElement(My.Title, null, entity.name), React.createElement(My.Body, null, entity.challenge && React.createElement(My.ChallengeLabel, {
    bubbleSize: 28,
    entity: entity.challenge
  }), entity.location && React.createElement(My.Label, {
    entityTypeName: "Location"
  }, React.createElement(My.LocationLabel, {
    entity: entity.location
  })), industries.length !== 0 && React.createElement(My.IconLabel, {
    icon: React.createElement(Icons.CrosshairCircle, null)
  }, industries.map(function (industry) {
    return industry.name;
  }).join(', ')), React.createElement(My.CountLabel, {
    entityTypeName: "FeedEntry",
    value: feedEntries
  }), React.createElement(My.CountLabel, {
    entityTypeName: "Person",
    value: positions
  }), React.createElement(My.CountLabel, {
    entityTypeName: "ImpactStory",
    value: impactStories
  })), entity.description && entity.description.text && React.createElement(My.Content, {
    tiny: true
  }, entity.description.text));
};
exports.OrganisationCardComponent = OrganisationCardComponent;
exports.OrganisationCardComponent.defaultProps = exports.OrganisationCardDefaultProps;
exports.OrganisationCard = React.memo(exports.OrganisationCardComponent);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29;